import React from "react";
import logo from "../images/logo.png";

const TopBar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 flex justify-between items-center p-0 bg-[rgba(255,255,255,0.1)] shadow-md md:pl-16 md:pr-10 z-10">
      {/* Logo */}
      <div className="flex items-center">
        <a
          href="https://iejl.org/"
          className="inline-block"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={logo} alt="Logo" className="h-20" />
        </a>
      </div>

      {/* Button */}
      <button
        className="bg-[#3A6EA5] text-white px-4 py-2 rounded-lg hover:bg-[#004E98] transition"
        onClick={() =>
          document
            .getElementById("founders-circle")
            .scrollIntoView({ behavior: "smooth" })
        }
      >
        Join as Founders’ Circle member
      </button>
    </nav>
  );
};

export default TopBar;
